export default "__VITE_PUBLIC_ASSET__70fee6d0__"